module.exports = __webpack_public_path__ + "media/luxury-2026/modern-exterior-1b1920d0.jpg";